import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const Segment = ({ segment }: SpecProps<"segment">) => {
  const { i18n } = useLingui();

  if (!segment) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.caravan.type",
    message: "Type of caravan",
    comment: "Field for 'type of caravan' in ad specification",
  });

  return <FieldValuePair field={field} value={segment} />;
};
